import { QueryClient } from "@tanstack/react-query";

/** Uygulama geneli TanStack Query varsayılanları (plan sözleşmesi: retry 1, staleTime 30 sn). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});
